module.exports = __webpack_public_path__ + "static/flags/CH-85a761180d26151f80bdd90f9927a1f4.gif";